import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ActionProgressState {
  actionName: string;
  visible: boolean;
  progress: number;
  message?: string;
  cancellable?: boolean;
  cancelling?: boolean;
}

const initialState: ActionProgressState | null = null;

const actionProgressSlice = createSlice({
  name: 'actionProgress',
  initialState: initialState as ActionProgressState | null,
  reducers: {
    start(
      _state,
      { payload: { actionName } }: PayloadAction<{ actionName: string }>
    ) {
      return { actionName, visible: false, progress: 0 };
    },
    update(
      state,
      {
        payload: { progress, message, cancellable },
      }: PayloadAction<{
        progress: number;
        message?: string;
        cancellable?: boolean;
      }>
    ) {
      if (state) {
        state.visible = true;
        state.progress = progress;
        state.message = message;
        if (cancellable !== undefined) state.cancellable = cancellable;
      }
    },
    finish() {
      return null;
    },
    cancel(state) {
      if (state) {
        state.cancelling = true;
      }
    },
  },
});

export const actionProgressReducer = actionProgressSlice.reducer;

export default actionProgressSlice.actions;
